/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Button, Modal } from 'antd';

function TaskDrawerOperatorFooterComponent({
  task,
  setIsEditing,
  setShowConclusionModal,
  scheduleType,
  confirmTask,
  denyTask,
  setShowOperatorFooter,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const currentUser = JSON.parse(localStorage.getItem('conecta__userData'));

  const getTaskStage = () => {
    let driverStage;
    switch (scheduleType) {
      case 'mainInstructor':
        return task?.mainInstructor?.stage?.id;
      case 'assistantInstructor':
        return task?.assistantInstructor?.stage?.id;
      case 'driver': {
        task?.driverList?.forEach((driver) => {
          if (driver.userId === currentUser?.id) {
            driverStage = driver.stage?.id;
          }
        });
        return driverStage;
      }
      default:
        return 0;
    }
  };

  const currentStageId = getTaskStage();

  // 3 = Confirmado (Aceito)
  let showConclusionBtn = false;
  if (scheduleType === 'driver') {
    showConclusionBtn =
      currentStageId === 3 &&
      !!task.driverList.find((driver) => driver.userId === currentUser?.id).trackingEnd;
  } else {
    showConclusionBtn = currentStageId === 3 && !!task[scheduleType].trackingEnd;
  }

  // 1 = Aguardando
  const showAcceptDenyBtn = currentStageId === 1;

  const handleConfirmTask = async () => {
    setIsLoading(true);
    await confirmTask(task);
    setIsEditing(false);
    setIsLoading(false);
    setIsConfirmModalOpen(false);
  };

  const buttons = [];

  // Exibe opções de Aceitar e Negar
  if (showAcceptDenyBtn) {
    buttons.push(
      <Button
        key="role-confirm"
        style={{
          backgroundColor: '#5cb85c', // Verde
          color: 'white',
          border: 'none',
          opacity: isLoading ? 0.3 : 1,
        }}
        loading={isLoading}
        onClick={() => setIsConfirmModalOpen(true)}
      >
        Aceitar
      </Button>,
      <Button
        key="role-deny"
        style={{
          backgroundColor: '#d9534f', // Vermelho
          color: 'white',
          border: 'none',
          opacity: isLoading ? 0.3 : 1,
        }}
        loading={isLoading}
        onClick={() => denyTask(task)}
      >
        Negar
      </Button>
    );
  }

  if (showConclusionBtn) {
    buttons.push(
      <Button
        key="conclusion"
        style={{
          backgroundColor: '#87CEEB', // Azul
          color: '#121212', // Preto
          border: 'none',
          opacity: isLoading ? 0.3 : 1,
        }}
        loading={isLoading}
        onClick={() => {
          setShowConclusionModal(true);
        }}
      >
        Concluir
      </Button>
    );
  }

  if (!buttons.length) {
    setShowOperatorFooter(false);
    return null;
  }
  setShowOperatorFooter(true);

  return (
    <>
      {buttons}
      <Modal
        title="Confirmar aceite"
        open={isConfirmModalOpen}
        onOk={handleConfirmTask}
        onCancel={() => setIsConfirmModalOpen(false)}
        okText="Sim"
        cancelText="Cancelar"
        closable={false}
        width="fit-content"
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: '#5cb85c',
            color: 'white',
            border: 'none',
          },
        }}
      >
        <h4>
          Deseja realmente <strong style={{ color: '#5cb85c' }}>aceitar</strong> esta tarefa?
        </h4>
      </Modal>
    </>
  );
}

export default TaskDrawerOperatorFooterComponent;
